.typography {
  margin: 0;
  font-family: var(--tuna-typography-fontFamily);
  color: inherit;
}

.body1 {
  font-size: var(--tuna-typography-body1-fontSize);
  font-weight: var(--tuna-typography-body1-fontWeight);
  line-height: var(--tuna-typography-body1-lineHeight);
  letter-spacing: var(--tuna-typography-body1-letterSpacing);
}

.body2 {
  font-size: var(--tuna-typography-body2-fontSize);
  font-weight: var(--tuna-typography-body2-fontWeight);
  line-height: var(--tuna-typography-body2-lineHeight);
  letter-spacing: var(--tuna-typography-body2-letterSpacing);
}

.caption {
  font-size: var(--tuna-typography-caption-fontSize);
  font-weight: var(--tuna-typography-caption-fontWeight);
  line-height: var(--tuna-typography-caption-lineHeight);
  letter-spacing: var(--tuna-typography-caption-letterSpacing);
}

.overline {
  font-size: var(--tuna-typography-overline-fontSize);
  font-weight: var(--tuna-typography-overline-fontWeight);
  line-height: var(--tuna-typography-overline-lineHeight);
  letter-spacing: var(--tuna-typography-overline-letterSpacing);
  text-transform: uppercase;
}

.subtitle1 {
  font-size: var(--tuna-typography-subtitle1-fontSize);
  font-weight: var(--tuna-typography-subtitle1-fontWeight);
  line-height: var(--tuna-typography-subtitle1-lineHeight);
}

.subtitle2 {
  font-size: var(--tuna-typography-subtitle2-fontSize);
  font-weight: var(--tuna-typography-subtitle2-fontWeight);
  line-height: var(--tuna-typography-subtitle2-lineHeight);
}

/* Heading sizes come from tokens.css (responsive) */
.h1 {
  font-size: var(--tuna-typography-h1-fontSize);
  font-weight: var(--tuna-typography-heading-fontWeight);
  line-height: var(--tuna-typography-h1-lineHeight);
  margin-top: var(--tuna-spacing-2);
  margin-bottom: var(--tuna-spacing-1);
}
.h2 {
  font-size: var(--tuna-typography-h2-fontSize);
  font-weight: var(--tuna-typography-heading-fontWeight);
  line-height: var(--tuna-typography-h2-lineHeight);
  margin-top: var(--tuna-spacing-2);
  margin-bottom: var(--tuna-spacing-1);
}
.h3 {
  font-size: var(--tuna-typography-h3-fontSize);
  font-weight: var(--tuna-typography-heading-fontWeight);
  line-height: var(--tuna-typography-h3-lineHeight);
  margin-top: var(--tuna-spacing-2);
  margin-bottom: var(--tuna-spacing-1);
}
.h4 {
  font-size: var(--tuna-typography-h4-fontSize);
  font-weight: var(--tuna-typography-heading-fontWeight);
  line-height: var(--tuna-typography-h4-lineHeight);
  margin-top: var(--tuna-spacing-2);
  margin-bottom: var(--tuna-spacing-1);
}
.h5 {
  font-size: var(--tuna-typography-h5-fontSize);
  font-weight: var(--tuna-typography-heading-fontWeight);
  line-height: var(--tuna-typography-h5-lineHeight);
  margin-top: var(--tuna-spacing-2);
  margin-bottom: var(--tuna-spacing-1);
}
.h6 {
  font-size: var(--tuna-typography-h6-fontSize);
  font-weight: var(--tuna-typography-heading-fontWeight);
  line-height: var(--tuna-typography-h6-lineHeight);
  margin-top: var(--tuna-spacing-1);
  margin-bottom: var(--tuna-spacing-1);
}

.button {
  font-size: var(--tuna-typography-button-fontSize);
  font-weight: var(--tuna-typography-button-fontWeight);
  line-height: var(--tuna-typography-button-lineHeight);
  letter-spacing: var(--tuna-typography-button-letterSpacing);
  text-transform: uppercase;
}

.colorPrimary {
  color: var(--tuna-palette-primary-main);
}

.colorSecondary {
  color: var(--tuna-palette-secondary-main);
}

.colorError {
  color: var(--tuna-palette-error-main);
}

.colorSuccess {
  color: var(--tuna-palette-success-main);
}

.colorTextSecondary {
  color: var(--tuna-palette-text-secondary);
}

.colorTextDisabled {
  color: var(--tuna-palette-text-disabled);
}

.noWrap {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gutterBottom {
  margin-bottom: 0.35em;
}

.alignCenter {
  text-align: center;
}

.alignRight {
  text-align: right;
}

.alignJustify {
  text-align: justify;
}
